import { tableParams, type TableCriteria } from '../components/common/tables/tableQuery';

export function skuTableParams(criteria: TableCriteria): URLSearchParams {
  const params = tableParams({ ...criteria, columnFilters: criteria.columnFilters.filter(filter => filter.id !== 'strips') });
  const strip = criteria.columnFilters.find(filter => filter.id === 'strips')?.value as Record<string, string> | undefined;
  for (const [key, field] of Object.entries({ label: 'strip_label', min: 'strip_threshold_min', max: 'strip_threshold_max' })) {
    if (strip?.[key] !== undefined && strip[key] !== '') params.set(field, strip[key]);
  }
  return params;
}
export const deviceTableParams = (criteria: TableCriteria) => tableParams(criteria);
export const auditTableParams = (criteria: TableCriteria) =>
  tableParams(criteria, new Set(['timestamp']), { user_id: 'actor_id', user_email: 'actor_email' });
